import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

/** PATCH /team/saved-views/{id} — rename, update config, and/or set as default. */
export default function useUpdateSavedView() {
  const queryClient = useQueryClient()

  const action = async ({ id, ...changes }) => {
    const response = await httpClient.patch(`team/saved-views/${id}`, changes)
    return response.data
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['saved-views'] })
    },
    onError: (error) => {
      const message =
        error?.response?.data?.errors?.name?.[0] ??
        error?.response?.data?.message ??
        "Couldn't update the view."
      toast.error(message)
    },
  })

  return { action: mutation.mutateAsync, status: mutation }
}
